import React, { createContext, useContext } from 'react';
import type { ItemCardPreviews, ItemPurchasePreview } from '../api';
import { SpellInvestigatorContext } from './SpellCastingContext';

const ItemPreviewsContext = createContext<ItemCardPreviews>({});
const MiskatonicTraumaContext = createContext(false);
export const MiskatonicTraumaProvider: React.FC<{ enabled?: boolean; children: React.ReactNode }> = ({ enabled, children }) => {
  const inherited = useContext(MiskatonicTraumaContext);
  return <MiskatonicTraumaContext.Provider value={enabled ?? inherited}>{children}</MiskatonicTraumaContext.Provider>;
};
export const useMiskatonicTraumaRules = () => useContext(MiskatonicTraumaContext);
export const ItemPurchaseContext = createContext<ItemPurchasePreview | undefined>(undefined);
export const ItemPreviewsProvider: React.FC<{ previews?: ItemCardPreviews; children: React.ReactNode }> = ({ previews, children }) => {
  const inherited = useContext(ItemPreviewsContext);
  return <ItemPreviewsContext.Provider value={previews ?? inherited}>{children}</ItemPreviewsContext.Provider>;
};
export const useItemWeaponPreview = (kind: string, id?: string) => {
  const previews = useContext(ItemPreviewsContext);
  const investigator = useContext(SpellInvestigatorContext);
  if (!id || !investigator) return undefined;
  const name = Object.keys(previews).find(name => name.toLowerCase() === investigator.toLowerCase());
  return name ? previews[name]?.[kind]?.[id] : undefined;
};
